// ============================================================
// EASY-TO-EDIT BUSINESS CONFIG — swap these for real client data
// ============================================================
export const BUSINESS = {
  name: "Maison Neuf",
  wordmark: "NEUF",
  fullName: "Maison Neuf — Hell's Kitchen",
  tagline: "Hair · Nails · Skin — after dark in Hell's Kitchen.",
  phoneDisplay: "(212) 555-0182",
  phoneHref: "tel:+12125550182",
  smsHref: "sms:+12125550182",
  email: "hello@maisonneufny.com",
  emailHref: "mailto:hello@maisonneufny.com",
  addressLine1: "555 Ninth Avenue",
  addressLine2: "Hell's Kitchen, New York, NY 10018",
  neighborhood: "Hell's Kitchen, Manhattan",
  crossStreets: "Between W 40th & W 41st Street",
  // Replace BOOKING_URL with your Vagaro / Boulevard / Fresha link.
  // When empty, the "Book Online" CTA routes to the on-site /book page.
  bookingUrl: "https://calendar.app.google/zGW7pCnzNPxsAxUz6",
  hours: [
    { day: "Monday", time: "Closed" },
    { day: "Tuesday – Thursday", time: "10:00 AM – 8:00 PM" },
    { day: "Friday", time: "9:00 AM – 9:00 PM" },
    { day: "Saturday", time: "9:00 AM – 8:00 PM" },
    { day: "Sunday", time: "11:00 AM – 6:00 PM" },
  ],
  transit: [
    "A · C · E at 42nd St–Port Authority — 3 min walk",
    "7 at Times Sq–42nd St — 6 min walk",
    "N · Q · R · W at 42nd St — 7 min walk",
  ],
  social: {
    instagram: "https://www.instagram.com/maisonneufny/",
    facebook: "https://www.facebook.com/maisonneufny",
  },
  handle: "@maisonneufny",
};

export const IMAGES = {
  heroInterior:
    "https://images.unsplash.com/photo-1773904215697-e6c21fc27ac2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBzYWxvbiUyMGludGVyaW9yfGVufDB8fHx8MTc4NDQ1NjgzOHww&ixlib=rb-4.1.0&q=85",
  hair: "https://images.pexels.com/photos/29204263/pexels-photo-29204263.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  hairAlt:
    "https://images.pexels.com/photos/7752412/pexels-photo-7752412.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  hairPortrait:
    "https://images.unsplash.com/photo-1568038479111-87bf80659645?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxlZGl0b3JpYWwlMjBwb3J0cmFpdCUyMGhhaXJ8ZW58MHx8fHwxNzg0NjEwMzE4fDA&ixlib=rb-4.1.0&q=85",
  nails:
    "https://images.unsplash.com/photo-1754799670312-8e7da8e40ad7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBtYW5pY3VyZSUyMG5haWwlMjBhcnQlMjBoYW5kc3xlbnwwfHx8fDE3ODQ2MTA0MjZ8MA&ixlib=rb-4.1.0&q=85",
  nailsAlt:
    "https://images.pexels.com/photos/4677845/pexels-photo-4677845.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  facial:
    "https://images.unsplash.com/photo-1643684391140-c5056cfd3436?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwzfHxmYWNpYWwlMjBza2luY2FyZSUyMHNwYSUyMHRyZWF0bWVudCUyMGNsb3NldXB8ZW58MHx8fHwxNzg0NjEwNDI2fDA&ixlib=rb-4.1.0&q=85",
  facialAlt:
    "https://images.pexels.com/photos/37229301/pexels-photo-37229301.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  waxing:
    "https://images.pexels.com/photos/29588096/pexels-photo-29588096.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  waxingAlt:
    "https://images.unsplash.com/photo-1519415387722-a1c3bbef716c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwyfHxleWVicm93JTIwd2F4aW5nJTIwZXN0aGV0aWNpYW4lMjBiZWF1dHl8ZW58MHx8fHwxNzg0NjEwNDI2fDA&ixlib=rb-4.1.0&q=85",
  skyline:
    "https://images.unsplash.com/photo-1583759311999-c8821f61e5b0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxOZXclMjBZb3JrJTIwQ2l0eSUyMHNreWxpbmUlMjBtYW5oYXR0YW4lMjBuaWdodHxlbnwwfHx8fDE3ODQ2MTA0MjZ8MA&ixlib=rb-4.1.0&q=85",
  baHairBefore:
    "https://static.prod-images.emergentagent.com/jobs/b071541b-0645-4c1e-b572-c65c2d086db5/images/dcfab3be100f8214ed7b7de39ba1c11bdf25833e2c2748c94c17f7ab40018746.jpeg",
  baHairAfter:
    "https://static.prod-images.emergentagent.com/jobs/b071541b-0645-4c1e-b572-c65c2d086db5/images/c38a4c773b60787ca13960eb2d45c8ccd7696b5036dcf0d1ce5c0fd1f119d30f.jpeg",
  baFacialBefore:
    "https://static.prod-images.emergentagent.com/jobs/b071541b-0645-4c1e-b572-c65c2d086db5/images/9aa2ef1f40810b610f7d0a1b917577606c9cde15feb2734b7fcb1a8bec016716.jpeg",
  baFacialAfter:
    "https://static.prod-images.emergentagent.com/jobs/b071541b-0645-4c1e-b572-c65c2d086db5/images/01d2799f5a910835ebf6f93dab4ace0ae24404322a13a552981822a0dd41c96f.jpeg",
  team: [
    "https://images.unsplash.com/photo-1618835962148-cf177563c6c0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBiZWF1dHklMjBzdHlsaXN0JTIwcG9ydHJhaXQlMjBoZWFkc2hvdCUyMHN0dWRpb3xlbnwwfHx8fDE3ODQ2MTA0MjZ8MA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjBiZWF1dHklMjBzdHlsaXN0JTIwcG9ydHJhaXQlMjBoZWFkc2hvdCUyMHN0dWRpb3xlbnwwfHx8fDE3ODQ2MTA0MjZ8MA&ixlib=rb-4.1.0&q=85",
    "https://images.pexels.com/photos/18777282/pexels-photo-18777282.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=640",
    "https://images.unsplash.com/photo-1607503873903-c5e95f80d7b9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBiZWF1dHklMjBzdHlsaXN0JTIwcG9ydHJhaXQlMjBoZWFkc2hvdCUyMHN0dWRpb3xlbnwwfHx8fDE3ODQ2MTA0MjZ8MA&ixlib=rb-4.1.0&q=85",
  ],
};
